<template>
  <div>
    <section class="d-flex flex-column container">
      <section class="align-self-center app-page">
        <div class="title-text mb-4 text-center">
          <h3>Enter business zip code</h3>
          <h5>Zip codes help determine what financing options you could be eligible for.</h5>
        </div>

        <div class="mb-4">
          <input id="zipid" name="zipid" class="form-control mx-auto" type="text"
            :class="{'is-invalid': isInvalid}"
            :disabled="submitting"
            maxlength="5"
            :placeholder="'Zip code'"
            :required="true"
            v-model="state.zip"
            v-maska data-maska="#####"
            @keyup="validateAndSubmit"
            @change="validateAndSubmit"
            @keyup.enter="validateAndSubmit"
            @blur="v$.$touch()"
          />

          <div class="invalid-feedback d-flex align-items-center mb-4" v-if="isInvalid">
            <i class="fa-light fa-circle-exclamation"></i>
            <div class="ms-1" v-for="error in v$.zip.$errors" :key="error.$uid">
              {{ error.$message }}
            </div>
          </div>
        </div>

        <div class="text-center">
          <button type="button" class="btn btn-primary"
            :class="{ 'disabled': isInvalid || submitting || validating }"
            :disabled="isInvalid || submitting || validating"
            @click="submitZipCode()"
          >
            <ButtonLoadingSpinner v-if="validating || submitting" />
            <span v-if="validating">Checking Zip</span>
            <span v-else>Continue</span>
          </button>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'

import { required, minLength, numeric, helpers } from '@vuelidate/validators'
const { withAsync, withMessage } = helpers

import debounce from 'lodash/debounce'

import { useBorrowerStore } from '~/store/borrower'
import { zipValidator } from '~/libs/validators/zipValidator'

export default {
  name: 'ZipCode',
  emits: ['invalidity'],
  setup: () => {
    const { $axios } = useNuxtApp()
    const state = reactive({
      zip: null,
    })

    const rules = {
      zip: {
        required,
        minLength: minLength(5),
        numeric,
        zipExists: withAsync(
          withMessage('Must be a valid zip code', zipValidator($axios))
        )
      }
    }

    const submitting = ref(false)
    const validating = ref(false)
    const v$ = useVuelidate(rules, state)

    return {
      state,
      submitting,
      validating,
      debouncedSubmit: null,
      v$
    }
  },
  computed: {
    isInvalid() {
      return this.v$ && this.v$.zip && this.v$.zip.$error && !this.validating
    }
  },

  mounted() {
    this.debouncedSubmit = debounce(this.submitZipCode, 5000)
  },

  methods: {
    async validateAndSubmit() {
      this.debouncedSubmit.cancel
      this.validating = true

      if (this.v$.zip.$invalid) {
        this.validating = false
        return
      }

      const validator = zipValidator(this.$axios)
      const zipValid = await validator(this.state.zip)

      if (zipValid) {
        this.validating = false
        this.debouncedSubmit()
      } else {
        this.validating = false
        this.v$.$touch()
      }
    },

    async submitZipCode () {
      if (this.state.zip.length === 5 && !this.isInvalid && !this.submitting) {
        this.submitting = true
        await useBorrowerStore(this.$pinia).setBorrowerZipId(this.state.zip)
        this.submitting = false
      }

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
